var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "subscription-card" }, [
    _c(
      "div",
      {
        staticClass: "delete-sub",
        on: {
          click: function ($event) {
            return _vm.$emit("deletePlan")
          },
        },
      },
      [_c("span", { staticClass: "material-icons" }, [_vm._v("delete")])]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "body" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.subscribe.plan.title)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "descriptions" }, [
        _c("div", { staticClass: "descriptions-item" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.subscribe.plan.altTitle)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "descriptions-item" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "value" }, [
            _vm._v(
              _vm._s(_vm.subscribe.period == "monthly" ? "Aylık" : "Yıllık")
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.subscribe.plan.type == "supsis"
          ? _c("div", { staticClass: "descriptions-item" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.details.agentCount)),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.subscribe.plan.type == "whatsapp" ||
        _vm.subscribe.plan.type == "whatsapp-business"
          ? _c("div", { staticClass: "descriptions-item" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.details.whatsappChannel)),
              ]),
            ])
          : _c("div", { staticClass: "descriptions-item" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "value" }),
            ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "image-wrapper" },
      [
        _c("DynamicSvg", {
          staticStyle: { width: "80px", height: "80px" },
          attrs: { name: _vm.subscribe.icon },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label" }, [
      _vm._v("Paket Türü"),
      _c("span", [_vm._v(":")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label" }, [
      _vm._v("Abonelik Türü"),
      _c("span", [_vm._v(":")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label" }, [
      _vm._v("Temsilci Sayısı"),
      _c("span", [_vm._v(":")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label" }, [
      _vm._v("Kanal Sayısı"),
      _c("span", [_vm._v(":")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label" }, [_c("span")])
  },
]
render._withStripped = true

export { render, staticRenderFns }